import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { zipCharacters } from '@parchment/validation-utils';
import ComposedTextField from '../ComposedField/ComposedTextField';
export default function PostalCode(_ref) {
  let {
    name = 'postalCode',
    label = 'Postal Code',
    autoComplete = 'postal-code',
    validators = [{
      message: 'Please enter a valid Postal Code',
      callback: zipCharacters
    }],
    country = 'USA',
    ...props
  } = _ref;
  const internationalValidators = [{
    message: 'Please enter a valid Postal Code',
    callback: () => {
      return true;
    }
  }];
  return /*#__PURE__*/React.createElement(ComposedTextField, _extends({}, props, {
    name: name,
    label: label,
    autoComplete: autoComplete,
    validators: ['USA', 'US'].indexOf(country.toUpperCase()) >= 0 ? validators : internationalValidators
  }));
}